export default __webpack_public_path__ + "static/lucediretta-c3043c993ba4825da17b502b16b411c0.gif";